import { z } from 'zod'

export const updateBillingConfigSchema = z.object({
  asaasApiKey: z.string().optional(),
  asaasEnvironment: z.enum(['sandbox', 'production']),
  accountType: z.enum(['cpf', 'cnpj']),
  dunningEnabled: z.boolean(),
  dunningDaysBefore: z.number().min(0).max(30).nullable().optional(),
  dunningDaysAfter: z.number().min(0).max(60).nullable().optional(),
  maxRetries: z.number().min(0).max(5).nullable().optional(),
  delinquencyBlockEnabled: z.boolean(),
  delinquencySoftBlockDays: z.number().min(1).max(60),
  delinquencyHardBlockDays: z.number().min(1).max(90),
  autoInvoiceEnabled: z.boolean(),
  municipalRegistration: z.string().nullable().optional(),
  municipalServiceCode: z.string().nullable().optional(),
  municipalServiceId: z.string().nullable().optional(),
  issRate: z.number().min(0).max(100).nullable().optional(),
  defaultServiceDescription: z.string().nullable().optional(),
})

export type UpdateBillingConfigFormData = z.infer<typeof updateBillingConfigSchema>

export const onboardingStep1Schema = z.object({
  accountType: z.enum(['cpf', 'cnpj'], {
    message: 'Selecione o tipo de conta',
  }),
})

export const onboardingStep2Schema = z.object({
  asaasApiKey: z.string().min(1, 'API Key e obrigatoria'),
  asaasEnvironment: z.enum(['sandbox', 'production']),
})

export const onboardingStep3Schema = z.object({
  dunningEnabled: z.boolean(),
  dunningDaysBefore: z.number().min(0).max(30).nullable(),
  dunningDaysAfter: z.number().min(0).max(60).nullable(),
  maxRetries: z.number().min(0).max(5).nullable(),
})

export const onboardingStep4Schema = z.object({
  autoInvoiceEnabled: z.boolean(),
  municipalRegistration: z.string().nullable().optional(),
  municipalServiceCode: z.string().nullable().optional(),
  issRate: z.number().min(0).max(100).nullable().optional(),
  defaultServiceDescription: z.string().nullable().optional(),
})

export type OnboardingStep1Data = z.infer<typeof onboardingStep1Schema>
export type OnboardingStep2Data = z.infer<typeof onboardingStep2Schema>
export type OnboardingStep3Data = z.infer<typeof onboardingStep3Schema>
export type OnboardingStep4Data = z.infer<typeof onboardingStep4Schema>
